'use strict';

var _ = require('lodash');

function buildDeepStructure(comp, map) {
    var children = comp.children || comp.components;
    if (!_.isEmpty(children)) {
        var _$omit$defaults;

        var components = _.map(children, function (child) {
            return buildDeepStructure(map[child], map);
        });
        return _(comp).omit(['components', 'parent']).defaults((_$omit$defaults = {}, _$omit$defaults[comp.id === 'masterPage' ? 'children' : 'components'] = components, _$omit$defaults)).value();
    }

    return _.omit(_.clone(comp), 'parent');
}

module.exports = {
    buildDeepStructure: buildDeepStructure
};
//# sourceMappingURL=flatStructureUtil.js.map